const state = {
  modalScheduleId: 0,
  isOngoingClass: false,
  modalMelonTvId: 0
}
const getters = {}

const actions = {
  openModalSchedule({ commit }, payload) {
    commit('setModalSchedule', payload)
  },
  openModalMelonTV({ commit }, payload) {
    commit('setModalMelonTV', payload)
  }

}
const mutations = {
  setModalSchedule(state, payload) {
    state.modalScheduleId = payload.scheduleId
    state.isOngoingClass = payload.isOngoingClass
  },
  setModalMelonTV(state, scheduleId) {
    state.modalMelonTvId = scheduleId
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
